module.exports = __webpack_public_path__ + "static/media/4.1340a8a5.jpg";